import { BookmarkDc } from "@evergis/api";
import { useMapViewActions } from "@evergis/react";
import { useMapView } from "ducks/mapView/useMapView";
import { api } from "evergis/api";
import { useBaseMap } from "hooks/project/useBaseMap";
import { useCallback, useMemo } from "react";
import { useProjectInfo, useProjectSrid, useProjectUpdate } from "ducks/project/hooks";

const createLayerImageLink = (layerName, { sr, position: [x, y], resolution }) => {
  const [imageWidth, imageHeight] = [800, 400];
  const [commonWidth, commonHeight] = [(imageWidth / 2) * resolution, (imageHeight / 2) * resolution];

  return api.layers.getLayerImage({
    name: layerName,
    extent: [x - commonWidth, y - commonHeight, x + commonWidth, y + commonHeight],
    size: [imageWidth, imageHeight],
    extentSr: sr,
  });
};

// eslint-disable-next-line max-lines-per-function
export const useBookmarks = () => {
  const [project, { loading: currentProjectLoading }] = useProjectInfo();
  const { name, content } = project;
  const mutation = useProjectUpdate();
  const { animateTo } = useMapViewActions();
  const spatialReference = useProjectSrid();
  const { baseMapName } = useBaseMap();
  const [{ position, resolution }] = useMapView();
  const bookmarks = useMemo(() => (content && content.bookmarks) || [], [content]);

  const updateBookmarks = useCallback(
    (value: BookmarkDc[]) =>
      mutation({
        ...project,
        name,
        content: {
          ...content,
          bookmarks: value,
        },
      }),
    [project, name, content, mutation],
  );

  const addBookmark = useCallback(
    ({ title }: Pick<BookmarkDc, "title">) => {
      const layerImage = createLayerImageLink(baseMapName, {
        sr: spatialReference,
        position,
        resolution,
      });

      return updateBookmarks([
        // FIXME: https://jr.everpoint.ru/browse/PUB-2350
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore TODO wrong type BookmarkDc (position property should be [number, number])
        ...bookmarks,
        {
          title,
          // FIXME: https://jr.everpoint.ru/browse/PUB-2350
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore TODO wrong type BookmarkDc (position property should be [number, number])
          position,
          resolution,
          image: layerImage,
        },
      ]);
    },
    [bookmarks, position, resolution, spatialReference],
  );

  const removeBookmark = useCallback(
    index => {
      const newBookmarks = [...bookmarks];

      newBookmarks.splice(index, 1);
      updateBookmarks(newBookmarks);
    },
    [bookmarks, updateBookmarks],
  );

  const goToBookmark = useCallback(
    ({ position: p, resolution: r }) => {
      animateTo({ position: p, resolution: r });
    },
    [animateTo],
  );

  return {
    bookmarks,
    loading: currentProjectLoading,
    goToBookmark,
    removeBookmark,
    addBookmark,
  };
};
